module.exports = __webpack_public_path__ + "static/img/Nature.227f574.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/Nature.png
// module id = Seeh
// module chunks = 1